// extracted by mini-css-extract-plugin
export default {"cover":"ColorPicker_cover__f5U3o","color":"ColorPicker_color__vEP7B","swatch":"ColorPicker_swatch__GX-+d","popover":"ColorPicker_popover__59sen"};